const ID = {
  Lang: {
    Code: "ID",
    TextEN: "Bahasa Inggris",
    TextVN: "Bahasa Vietnam",
  },
  Login: {
    ErrorEmail: "Silakan masukkan email!",

    LoginDescription: "Masukkan email dan kata sandi Anda untuk masuk.",
    ButtonText: "Masuk",
  },
  hero: {
    title: "Alat AI serbaguna Anda",
    description:
      "Terjemahkan bahasa dan file dengan cepat menggunakan teknologi AI canggih",
  },

  tabs: {
    translate: "Terjemahan bahasa",
    file: "Terjemahkan File",
    compress: "Kompres gambar",
  },

  file: {
    section_title: "Terjemahkan File",
    section_description:
      "Unggah file dan terjemahkan seluruh konten ke bahasa lain",
    from_language: "Bahasa sumber",
    to_language: "Bahasa tujuan",
    drag_text: "Seret dan lepas file di sini atau",
    choose_file: "Pilih file",
    support_text: "Mendukung DOC, DOCX, XLSX, PPTX, PDF",
    translating: "Sedang menerjemahkan dokumen...",
    translating_short: "📄 Sedang menerjemahkan",
    translating_short_complete: "📄 Sedang menerjemahkan seluruh dokumen",
    translate_now: "Terjemahkan sekarang",
  },

  note: {
    review_note_before: "Catatan: Anda memiliki",
    review_note_after:
      "kali pratinjau dokumen. Jika sudah habis, silakan lakukan pembayaran untuk mendapatkan kembali kuota pratinjau dokumen.",
    line1: "● Mendukung banyak format: Word, Excel, PPTX...",
    line2:
      "● Mempertahankan layout tabel, gambar, dan memungkinkan Anda melihat pratinjau hasil terjemahan sebelum pembayaran.",
    line3: "● Mendukung banyak bahasa populer dan bahasa khusus",
    line4: "● Proses cepat, mudah digunakan, tidak memerlukan keahlian teknis.",
    line5:
      "● Menyimpan riwayat terjemahan agar pengguna mudah mengunduh kembali.",
    warning:
      "* Catatan: Setelah diterjemahkan, jumlah kata dalam bahasa tujuan bisa lebih panjang atau lebih pendek dibandingkan layout asli. Silakan sesuaikan ukuran font agar cocok dengan layout.",
  },

  preview: {
    loading_title: "Sedang menyiapkan pratinjau...",
    loading_desc: "AI sedang merender dokumen, silakan tunggu sebentar.",
    title: "📄 Pratinjau dokumen",
    note: "Lakukan pembayaran sekarang untuk mengunduh hasil terjemahan lengkap.",
    choose_payment_method: "Pilih metode pembayaran",
    payment: "Pembayaran",
    download: "Unduh",
    must_pay: "Silakan lakukan pembayaran sebelum mengunduh",
  },

  feature: {
    format: {
      title: "Banyak format",
      desc: "Mendukung PDF, Word, TXT",
    },
    security: {
      title: "Keamanan",
      desc: "File dienkripsi dengan aman",
    },
    layout: {
      title: "Mempertahankan format",
      desc: "Menjaga layout asli",
    },
  },

  auth: {
    login_required: "Silakan masuk untuk menggunakan fitur ini!",
    loginSuccess: "Berhasil masuk",
    loginFailed: "❌ Gagal masuk",
  },

  error: {
    upload_fail: "❌ Gagal mengunggah file",
    unsupported_format: "❌ Format file tidak didukung",
    translate_fail:
      "❌ Saat ini server sedang dalam proses pemeliharaan sehingga file belum dapat diterjemahkan. Silakan coba lagi nanti. Mohon maaf atas ketidaknyamanan ini.",
    qr_fail: "❌ Gagal mengambil kode pembayaran",
  },

  pdf: {
    selectPdfProcessingModeBeforeStart:
      "File PDF perlu memilih mode pemrosesan sebelum mulai diterjemahkan.",
    selectPdfTranslationMode: "Pilih mode terjemahan PDF",
    only_text: {
      title: "Hanya terjemahkan teks, pertahankan gambar asli",
      desc: "Mempertahankan gambar dan layout PDF asli, hanya menerjemahkan bagian teks. File hasil terjemahan dapat diedit.",
    },
    text_or_image: {
      title: "Terjemahkan seluruh konten dan gambar dalam file",
      desc: "Menerjemahkan teks serta teks di dalam gambar, sekaligus mempertahankan layout file. File hasil terjemahan dapat diedit.",
    },
    full_image: {
      title: "Terjemahkan menjadi PDF berbentuk gambar",
      desc: "Mengekspor hasil sebagai PDF yang berisi gambar setelah diterjemahkan.",
    },
  },

  common: {
    close: "Tutup",
    loading: "Sedang memuat...",
    noData: "Tidak ada data",
    loadMore: "Lihat selengkapnya",
    ok: "Setuju",
    delete: "Hapus",
  },

  menu: {
    home: "Beranda",
    blog: "Blog",
    faq: "FAQ",
  },

  user: {
    transactionHistory: "Riwayat transaksi",
    logout: "Keluar",
  },

  blog: {
    notFound: "Artikel tidak ditemukan",
    relatedPosts: "Artikel terkait",
    authorAdmin: "Admin",
    pageTitle: "Blog & Berbagi",
    pageDescription:
      "Pengetahuan, panduan, dan pembaruan terbaru tentang AI Tools",
    noMorePosts: "Semua artikel telah ditampilkan",
  },

  seo: {
    blogTitleFallback: "Terjemahan dokumen online | MikoTech",
    blogDescriptionFallback:
      "Terjemahkan dokumen online dengan cepat, akurat, dan aman. Mendukung PDF, Word, Excel, PPT, dan gambar.",
    blogKeywordsFallback:
      "terjemahan dokumen, terjemahkan file pdf, terjemahan bahasa Inggris",
  },

  payment: {
    complete: {
      title: "Informasi file yang telah dibayar",
    },

    fileName: "Nama file",
    fileSize: "Ukuran file",
    translateFrom: "Diterjemahkan dari",
    paymentStatus: "Pembayaran",

    paid: "Sudah dibayar",
    unpaid: "Belum dibayar",

    download: "Unduh",
    transactionNotFound: "Kode transaksi tidak ditemukan",
    expirationDate: "Tanggal kedaluwarsa",
  },

  transaction: {
    title: "Riwayat transaksi",
    note: "Daftar file yang telah diunggah untuk diterjemahkan. Anda dapat melakukan pembayaran atau mengunduh file hasil terjemahan setelah pembayaran selesai.",
    fileDeleted: "File ini telah dihapus",
    notiteDeleteFile: "Apakah Anda yakin ingin menghapus file ini?",
    searchPlaceholder: "Cari berdasarkan nama file...",

    table: {
      fileName: "Nama file",
      fileSize: "Ukuran file",
      language: "Bahasa",
      status: "Status",
      price: "Harga",
      action: "Aksi",
      expirationDate: "Tanggal kedaluwarsa",
    },

    status: {
      all: "Semua status",
      paid: "Sudah dibayar",
      unpaid: "Belum dibayar",
    },
    delete: "Hapus",
    download: "Unduh",
    pay: "Bayar",
    mustPayFirst: "Silakan lakukan pembayaran sebelum mengunduh",
    getQrFail: "Gagal mengambil kode pembayaran",
  },

  pagination: {
    prev: "Sebelumnya",
    next: "Berikutnya",
  },

  faq: {
    title: "Pertanyaan yang sering diajukan",
    description:
      "Ingin memahami lebih lanjut tentang layanan terjemahan dokumen? Silakan lihat jawaban di bawah ini!",
  },

  translate: {
    terms:
      "Dengan melanjutkan, saya menyatakan setuju dengan <termsLink>syarat dan kebijakan</termsLink> platform, serta bertanggung jawab penuh atas terjemahan yang saya lakukan.",
    selectTone: "Pilih gaya bahasa",
    analyzing_document: "Sedang menganalisis dokumen...",
    extracting_content: "Sedang mengekstrak konten...",
    ai_translating: "Sedang menerjemahkan dengan AI...",
    rebuilding_layout: "Sedang menyusun ulang layout...",
    finalizing_document: "Sedang menyelesaikan dokumen...",
    ai_processing:
      "Dokumen sedang diproses. Proses akan berjalan otomatis secara terus-menerus hingga selesai.",
    NotitePdf:
      " File .PDF saat ini hanya mendukung terjemahan konten teks dalam file dan belum dapat mempertahankan format asli. Hasil keluaran akan berupa file berisi konten yang telah diterjemahkan dalam bentuk teks biasa.",
  },

  translation: {
    fileRetentionNotice: "Catatan: File akan dihapus setelah 30 hari.",
    keepThisPageOpen:
      "Silakan tetap buka halaman ini. Setelah terjemahan selesai, sistem akan otomatis menutup layar pemrosesan dan membuka halaman pratinjau.",
    emailNotice:
      "Ketika dokumen selesai diterjemahkan, sistem akan mengirimkan notifikasi email kepada Anda.",
  },
  footer: {
    productOf: "© 2026. Produk dari Miko Tech",

    description:
      "Platform terjemahan dokumen online berbasis AI yang membantu memproses file dengan cepat, mudah digunakan, dan aman.",
    badge: "Platform Terjemahan AI",
    contactTitle: "Informasi kontak",
    supportTitle: "Kebijakan dukungan",

    copyright: "© 2026 Docme.vn. Produk dari Miko Tech.",
    terms: "Ketentuan",
    privacy: "Privasi",

    supportLinks: {
      termsAndPolicies: "Kebijakan & Ketentuan Penggunaan",
      paymentPolicy: "Kebijakan pembayaran",
      privacyPolicy: "Kebijakan privasi",
      userGuide: "Panduan penggunaan",
      contactInfo: "Informasi kontak",
    },
  },
  fileSizeModal: {
    title: "File melebihi batas ukuran yang diizinkan",
    heading: "Ukuran file terlalu besar",
    descBefore: "File yang Anda pilih berukuran",
    descAfter: "Sistem hanya mendukung file maksimal",
    confirm: "Saya mengerti",
  },
  address:
    "Lantai 4B, 485B Jalan Nguyen Dinh Chieu, Kelurahan Ban Co, Kota Ho Chi Minh, Vietnam",
};

export default ID;
